import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import './Gallery.css';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Gallery images from the Gallery folder
  const galleryImages = [
    {
      id: 1,
      src: require('../assets/images/DSCF6146.jpg'),
      title: "Performance Photo",
      alt: "Tahir Palali Performance"
    },
    {
      id: 2,
      src: require('../assets/images/DSCF6254-2.jpg'),
      title: "Concert Performance",
      alt: "Tahir Palali Concert"
    },
    {
      id: 3,
      src: require('../assets/images/DSCF7045.jpg'),
      title: "Live Performance",
      alt: "Tahir Palali Live"
    },
    {
      id: 4,
      src: require('../assets/images/DSCF7046.jpg'),
      title: "Stage Performance",
      alt: "Tahir Palali Stage"
    },
    {
      id: 5,
      src: require('../assets/images/DSCF7047.jpg'),
      title: "Musical Performance",
      alt: "Tahir Palali Musical"
    },
    {
      id: 6,
      src: require('../assets/images/DSCF7048.jpg'),
      title: "Artist Performance",
      alt: "Tahir Palali Artist"
    },
    {
      id: 7,
      src: require('../assets/images/DSCF7049.jpg'),
      title: "Concert Moment",
      alt: "Tahir Palali Concert Moment"
    },
    {
      id: 8,
      src: require('../assets/images/DSCF7055.jpg'),
      title: "Performance Shot",
      alt: "Tahir Palali Performance Shot"
    },
    {
      id: 9,
      src: require('../assets/images/DSCF7056.jpg'),
      title: "Live Music",
      alt: "Tahir Palali Live Music"
    },
    {
      id: 10,
      src: require('../assets/images/DSCF7069-2.jpg'),
      title: "Stage Presence",
      alt: "Tahir Palali Stage Presence"
    },
    {
      id: 11,
      src: require('../assets/images/DSCF7080_1.jpg'),
      title: "Concert Performance",
      alt: "Tahir Palali Concert"
    },
    {
      id: 12,
      src: require('../assets/images/O+Kapak_yazisiz.jpg'),
      title: "Album Artwork",
      alt: "Tahir Palali Album O"
    }
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    const currentIndex = galleryImages.findIndex(img => img.id === selectedImage.id);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % galleryImages.length;
    } else {
      newIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    }
    
    setSelectedImage(galleryImages[newIndex]);
  };

  return (
    <div className="gallery-page">
      <Navigation />
      
      <div className="gallery-content">
        <h1 className="page-title">GALLERY</h1>
        
        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div 
              key={image.id}
              className="gallery-item"
              onClick={() => openModal(image)}
            >
              <img 
                src={image.src} 
                alt={image.alt}
                className="gallery-image"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Modal for enlarged image */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeModal}>×</button>
            <button className="nav-button prev-button" onClick={() => navigateImage('prev')}>‹</button>
            <button className="nav-button next-button" onClick={() => navigateImage('next')}>›</button>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="modal-image"
            />
            <div className="modal-title">{selectedImage.title}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;